import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  form: {
    padding: 0,
    backgroundColor: "inherit",
    maxWidth: 360,
    maxHeight: 560,
    margin: "auto",
  },
  input: {
    marginBottom: 0,
    "& .MuiOutlinedInput-root": {
      height: "100%",
    },
  },
  // The mark only ever shows on the disabled field, so it is dimmed to match
  // the greyed-out address beside it rather than sitting at full strength.
  googleMark: {
    display: "flex",
    opacity: 0.5,
  },
  // Sits below the three fields and above the Log In row, which is where the
  // ticket puts every Google failure on this page.
  googleAlert: {
    width: "100%",
    whiteSpace: "pre-line",
  },
  warning: {
    "& .MuiOutlinedInput-root": {
      borderColor: theme.palette.warning.main,
      "& fieldset": {
        borderColor: theme.palette.warning.main,
      },
    },
    "& .MuiFormLabel-root": {
      color: theme.palette.warning.main,
    },
  },
}));
export default styles;
